import { render, staticRenderFns } from "./bo-product-details.vue?vue&type=template&id=5261c251"
import script from "./bo-product-details.vue?vue&type=script&lang=js"
export * from "./bo-product-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports